import { createFileRoute, redirect } from '@tanstack/react-router'
import type { AuthRefusalReason } from '@depanneo/types'
import { LOGIN_REASON_PARAM, isAuthRefusalReason } from '@/constants/login'
import { useAuthStore } from '@/store/auth'
import { useOrgStore } from '@/store/org'
import {
  safeRelativeRedirect,
  toRouterTarget,
} from '@/shared/utils/route-utils/redirect-utils'

interface LoginSearch {
  redirect?: string
  reason?: AuthRefusalReason
}

export const Route = createFileRoute('/(login)/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    const redirectTo = search.redirect
    const reason = search[LOGIN_REASON_PARAM]
    return {
      redirect: typeof redirectTo === 'string' ? redirectTo : undefined,
      reason: isAuthRefusalReason(reason) ? reason : undefined,
    }
  },
  beforeLoad: async ({ search }) => {
    const { userId } = useAuthStore.getState()
    const { organizationId } = useOrgStore.getState()

    if (userId && organizationId) {
      // Already authenticated: honor a validated deep link (same guard as the
      // login mutation) instead of dumping the user on the dashboard.
      const target = safeRelativeRedirect(search.redirect)
      if (target) {
        throw redirect(toRouterTarget(target))
      }
      throw redirect({
        to: '/org/$orgId/dashboard',
        params: { orgId: organizationId },
      })
    }
  },
})
